import { render, staticRenderFns } from "./update-quote.vue?vue&type=template&id=01d656fa&scoped=true"
import script from "./update-quote.vue?vue&type=script&lang=js"
export * from "./update-quote.vue?vue&type=script&lang=js"
import style0 from "./update-quote.vue?vue&type=style&index=0&id=01d656fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d656fa",
  null
  
)

export default component.exports